import { useEffect, useState } from "react";
import swal from "sweetalert2";
import { useHooksUser } from "../../../hooks";
import {
    FragmentHeaderUser,
    FragmentTableUser,
    FragmentAddEditUser,
    FragmentListPpe,
} from "../fragments.hrm";
import { WidgetModal } from "../../modules.widgets";

export function PageUser() {
    const [modalTitle, setModalTitle]     = useState("");
    const [modalContent, setModalContent] = useState(null);
    const [modalSize, setModalSize]       = useState("lg");
    const [isModalOpen, setIsModalOpen]   = useState(false);
    const [refetch, setRefetch]           = useState(false);

    const { loading, users, getUser, deleteUser } = useHooksUser();

    useEffect(() => { getUser(); }, [refetch]);

    const onRefetch    = () => setRefetch((prev) => !prev);
    const openModal    = (title, content, size = "lg") => {
        setModalTitle(title);
        setModalContent(content);
        setModalSize(size);
        setIsModalOpen(true);
    };
    const closeModal   = () => setIsModalOpen(false);

    const addUser = () =>
        openModal(
            "Registrar Nuevo Empleado",
            <FragmentAddEditUser onRefetch={onRefetch} user={{}} onClose={closeModal} />,
            "xl"
        );

    const updateUser = (data) =>
        openModal(
            "Actualizar Empleado",
            <FragmentAddEditUser onRefetch={onRefetch} user={data} onClose={closeModal} />,
            "xl"
        );

    const onDeleteUser = async (data) => {
        const result = await swal.fire({
            title: "¿Está seguro?",
            text: "Si acepta, no podrás revertir esto.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#16a34a",
            cancelButtonColor:  "#dc2626",
            confirmButtonText:  "Sí, eliminar",
            cancelButtonText:   "Cancelar",
        });

        if (result.isConfirmed) {
            try {
                await deleteUser(data.id);
                onRefetch();
                swal.fire({ title: "Eliminado", text: "El empleado ha sido eliminado.", icon: "success", timer: 1500, showConfirmButton: false });
            } catch (error) {
                console.error(error);
                swal.fire({ title: "Error", text: "No se pudo eliminar el empleado.", icon: "error" });
            }
        }
    };

    const addPpe = (data) =>
        openModal(
            "EPPs del Empleado",
            <FragmentListPpe user={data} />,
            "lg"
        );

    return (
        <>
            {/* Page header */}
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                            Gestión de Empleados
                        </h1>
                        <nav aria-label="breadcrumb">
                            <ol className="flex items-center gap-2 text-sm">
                                <li className="text-blue-600 dark:text-blue-400">RR.HH.</li>
                                <li className="text-gray-400 dark:text-gray-500 select-none">/</li>
                                <li className="text-gray-700 dark:text-gray-300 font-medium">Empleados</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            {/* Main card */}
            <section>
                <div className="max-w-full px-4">
                    <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm overflow-hidden">

                        {/* Card header */}
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                            <div>
                                <h2 className="text-base font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                                    <i className="fas fa-users text-blue-500"></i>
                                    Lista de Empleados
                                </h2>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                    {users ? users.length : 0} empleados · ordenados por código ascendente
                                </p>
                            </div>
                            <FragmentHeaderUser addUser={addUser} />
                        </div>

                        {/* Card body */}
                        {loading ? (
                            <div className="flex flex-col items-center justify-center py-16 gap-3">
                                <div className="h-10 w-10 rounded-full border-4 border-blue-200 border-t-blue-600 animate-spin"></div>
                                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Cargando empleados...</p>
                                <p className="text-xs text-gray-400 dark:text-gray-500">Por favor espera mientras se cargan los datos</p>
                            </div>
                        ) : (
                            <FragmentTableUser
                                users={users}
                                updateUser={updateUser}
                                onDeleteUser={onDeleteUser}
                                addPpe={addPpe}
                            />
                        )}
                    </div>
                </div>
            </section>

            {/* Modal */}
            <WidgetModal
                isOpen={isModalOpen}
                onClose={closeModal}
                title={modalTitle}
                size={modalSize}
            >
                {modalContent}
            </WidgetModal>
        </>
    );
}
